import BaseAPI from 'api/BaseAPI';

class LanguageAPI extends BaseAPI {
    basePath = 'cap/';

    constructor() {
        super();
    }

    async getLanguageOptions() {
        let languageOptions;
          try {
            const response = await this.get({
                path: `${this.basePath}languages`,
            });
            languageOptions = response.language_options;
        } catch (e) {
            throw Error(e.responseJSON);
        }
        return languageOptions;
    }
}


export const languageAPI = new LanguageAPI();

